import apiFetch from '../apiFetch'

export default function (token, financingTypeProduct) {
  return apiFetch({ endPoint: 'SaleType/Insert/', method: 'POST', body: financingTypeProduct, token: token })
}
